import { Row as AntRow, RowProps as AntRowProps } from 'antd';

interface RowProps extends AntRowProps {}

const Row: React.FC<RowProps> = (props) => <AntRow {...props} />;
export default Row;
